const plugin = require('tailwindcss/plugin');

module.exports = {
  corePlugins: {
    container: false
  },
  // purge: {
  //   enabled: true,
  //   content: ['./src/**/*.js'],
  //   options: {
  //     safelist: [/grid-/]
  //   }
  // },
  important: true,

  theme: {
    fontFamily: {
      primary: ['Nunito Sans', 'sans-serif'],
      secondary: ['proxima-nova', 'sans-serif'],
      saira: ['Saira', 'sans-serif'],
      audi: ['Audi', 'sans-serif'],
      audiwide: ['AudiWide', 'sans-serif']
    },
    screens: {
      xs: '400px',
      sm: '640px',
      md: '768px',
      md2: '800px',
      md3: '810px',
      lg: '1025px',
      lg2: '1280px',
      lg3: '1440px',
      xl: '1476px',
      xl2: '1800px'
    },
    extend: {
      colors: {
        primary: '#2094e7',
        secondary: '#233741',
        lma: '#00AFFF',
        'secondary-two': '#e0e7f5',
        'lma-gray': '#F8F9FA',
        'lma-darkgray': '#696969',
        myway: {
          DEFAULT: '#96C11F',
          light: '#96C11F',
          dark: '#4D9D2C',
          darker: '#11597D',
          darkest: '#0C416A'
        },
        aap: {
          DEFAULT: '#BC2F37',
          gray: '#f2f2f2'
        }
      },
      borderRadius: {
        3: '3px',
        4: '4px',
        50: '50px'
      },
      fontSize: {
        9: '9px',
        10: '10px',
        11: '11px',
        12: '12px',
        13: '13px',
        14: '14px',
        15: '15px',
        16: '16px',
        17: '17px',
        18: '18px',
        19: '19px',
        20: '20px',
        21: '21px',
        22: '22px',
        23: '23px',
        24: '24px',
        26: '26px',
        27: '27px',
        28: '28px',
        29: '29px',
        30: '30px',
        32: '32px',
        33: '33px',
        35: '35px',
        36: '36px',
        39: '39px',
        40: '40px',
        45: '45px',
        48: '48px',
        52: '52px',
        60: '60px'
      },

      spacing: {
        '2px': '2px',
        '0.3125rem': '.3125rem',
        '0.9375rem': '.9375rem',
        '1.0625rem': '1.0625rem',
        '1.125rem': '1.125rem',
        '1.375rem': '1.375rem',
        '1.5625rem': '1.5625rem',
        '3.120rem': '3.120rem',
        '3.125rem': '3.125rem',
        '17.5rem': '17.5rem',
        '19.5rem': '19.5rem',
        1.25: '0.313rem',
        4.5: '1.125rem',
        5.5: '1.375rem',
        8.5: '2.125rem',
        9.5: '2.375rem',
        13: '3.25rem',
        15: '3.75rem',
        15.5: '3.875rem',
        17: '4.25rem',
        18: '4.5rem',
        19: '4.75rem',
        21.25: '21.25rem',
        22: '5.5rem',
        23.5: '5.875rem',
        25: '6.25rem',
        26: '6.5rem',
        27: '6.75rem',
        30: '7.5rem',
        33: '8.25rem',
        34: '8.5rem',
        35: '8.75rem',
        38: '9.5rem',
        39: '9.75rem',
        46: '11.5rem',
        50: '12.5rem',
        53: '13.25rem',
        54: '13.5rem',
        55: '13.75rem',
        59: '14.75rem',
        62: '15.5rem',
        70: '17.5rem',
        74: '18.5rem',
        75: '18.75rem',
        104: '26rem',
        112: '28rem',
        120: '30rem',
        122: '31rem',
        124: '32rem',
        128: '34rem',
        150: '150px',
        152: '38rem',
        160: '40rem',
        168: '42rem',
        172: '43rem',
        174: '43.5rem',
        175: '43.75rem',
        200: '50rem',
        300: '300px',
        650: '650px',
        '20px': '20px',
        '24px': '24px',
        '30px': '30px',
        '49px': '49px',
        '56px': '56px',
        '60px': '60px',
        '98px': '98px',
        '101px': '101px',
        '113px': '113px',
        '116px': '116px',
        '5%': '5%',
        '45%': '45%',
        '55%': '55%',
        '95%': '95%',
        input: 43
      },

      minWidth: (theme) => theme('spacing'),
      maxWidth: (theme) => theme('spacing'),
      minHeight: (theme) => theme('spacing'),
      maxHeight: (theme) => theme('spacing'),

      zIndex: {
        '-1': -1,
        '-10': '-10',
        1: 1,
        2: 2,
        60: 60,
        70: 70,
        80: 80,
        90: 90,
        100: 100
      },
      lineHeight: {
        0.81818: '.81818',
        0.875: '.875',
        16: '16px',
        18: '18px',
        19: '19px',
        20: '20px',
        21: '21px',
        22: '22px',
        23: '23px',
        24: '24px',
        25: '25px',
        26: '26px',
        27: '27px',
        28: '28px',
        29: '29px',
        30: '30px',
        31: '31px',
        32: '32px',
        36: '36px',
        40: '40px',
        45: '45px'
      }
    }
  },
  variants: {
    extend: {
      borderWidth: ['odd', 'even'],
      padding: ['first', 'last', 'odd', 'even'],
      backgroundColor: ['odd', 'even', 'hover', 'disabled'],
      opacity: ['disabled'],
      position: ['hover'],
      width: ['responsive', 'hover', 'focus', 'group-hover'],
      height: ['responsive', 'hover', 'focus'],
      borderRadius: ['responsive', 'hover', 'focus']
    }
  },
  plugins: [
    function ({ addComponents }) {
      addComponents({
        '.container': {
          maxWidth: 1416,
          margin: '0 auto',
          '@media (max-width: 1440px)': {
            paddingLeft: '2rem',
            paddingRight: '2rem'
          }
        }
      });
    },
    plugin(function ({ addUtilities }) {
      const calcUtilities = {
        '.w-half-minus-1-rem': {
          width: 'calc(50% - 1rem)'
        },
        '.w-third-minus-1-rem': {
          width: 'calc(33% - 1rem)'
        },

        '.w-quarter-minus-1-rem': {
          width: 'calc(25% - 1rem)'
        },

        '.w-half-minus-quarter-rem': {
          width: 'calc(50% - 0.25rem)'
        },
        '.w-third-minus-half-rem': {
          width: 'calc(33% - 0.5rem)'
        },

        '.w-quarter-minus-three-quarter-rem': {
          width: 'calc(25% - 0.75rem)'
        },

        '.min-h-content-desktop': {
          minHeight: 'calc(100vh - 472px)'
        }
      };

      addUtilities(calcUtilities, ['responsive']);
    }),

    plugin(function ({ addBase, config, theme }) {
      // const mobile = {
      //   h1: {
      //     fontSize: `${config('theme.fontSize.28')} !important`,
      //     fontFamily: `${config('theme.fontFamily.secondary')} !important`,
      //     lineHeight: `${config('theme.lineHeight.36')} !important`,
      //     fontWeight: 'bold',
      //     color: `${config('theme.colors.primary')} !important`
      //   },
      //   h2: {
      //     fontSize: `${config('theme.fontSize.24')} !important`,
      //     fontFamily: `${config('theme.fontFamily.secondary')} !important`,
      //     lineHeight: `${config('theme.lineHeight.32')} !important`,
      //     fontWeight: 'bold',
      //     color: `${config('theme.colors.primary')} !important`
      //   },
      //   h3: {
      //     fontSize: `${config('theme.fontSize.24')} !important`,
      //     fontFamily: `${config('theme.fontFamily.primary')} !important`,
      //     lineHeight: `${config('theme.lineHeight.32')} !important`,
      //     fontWeight: 'medium',
      //     color: `${config('theme.colors.primary')} !important`
      //   },
      //   h4: {
      //     fontSize: `${config('theme.fontSize.15')} !important`,
      //     fontFamily: `${config('theme.fontFamily.secondary')} !important`,
      //     lineHeight: `${config('theme.lineHeight.24')} !important`,
      //     fontWeight: 'bold',
      //     color: `${config('theme.colors.primary')} !important`
      //   },
      //   h5: {
      //     fontSize: `${config('theme.fontSize.15')} !important`,
      //     fontFamily: `${config('theme.fontFamily.primary')} !important`,
      //     lineHeight: `${config('theme.lineHeight.24')} !important`,
      //     fontWeight: 'bold',
      //     color: `${config('theme.colors.primary')} !important`
      //   },
      //   body: {
      //     fontFamily: `${config('theme.fontFamily.primary')} !important`,
      //     fontSize: `${config('theme.fontSize.14')}`,
      //     color: `${config('theme.colors.primary')} !important`
      //   },
      //   '.title': {
      //     fontFamily: `${config('theme.fontFamily.primary')} !important`
      //   }
      // };
      // const desktop = {
      //   [`@media (min-width: ${768}px)`]: {
      //     h1: {
      //       fontSize: `${config('theme.fontSize.40')} !important`,
      //       fontFamily: `${config('theme.fontFamily.secondary')} !important`,
      //       lineHeight: `${config('theme.lineHeight.52')} !important`,
      //       fontWeight: 'bold',
      //       color: `${config('theme.colors.primary')} !important`
      //     },
      //     h2: {
      //       fontSize: `${config('theme.fontSize.32')} !important`,
      //       fontFamily: `${config('theme.fontFamily.secondary')} !important`,
      //       lineHeight: `${config('theme.lineHeight.42')} !important`,
      //       fontWeight: 'bold',
      //       color: `${config('theme.colors.primary')} !important`
      //     },
      //     h3: {
      //       fontSize: `${config('theme.fontSize.24')} !important`,
      //       fontFamily: `${config('theme.fontFamily.primary')} !important`,
      //       lineHeight: `${config('theme.lineHeight.32')} !important`,
      //       fontWeight: 'medium',
      //       color: `${config('theme.colors.primary')} !important`
      //     },
      //     h4: {
      //       fontSize: `${config('theme.fontSize.15')} !important`,
      //       fontFamily: `${config('theme.fontFamily.secondary')} !important`,
      //       lineHeight: `${config('theme.lineHeight.24')} !important`,
      //       fontWeight: 'bold',
      //       color: `${config('theme.colors.primary')} !important`
      //     },
      //     h5: {
      //       fontSize: `${config('theme.fontSize.15')} !important`,
      //       fontFamily: `${config('theme.fontFamily.primary')} !important`,
      //       lineHeight: `${config('theme.lineHeight.24')} !important`,
      //       fontWeight: 'bold',
      //       color: `${config('theme.colors.primary')} !important`
      //     },
      //     body: {
      //       fontSize: `${config('theme.fontSize.15')} !important`,
      //       fontFamily: `${config('theme.fontFamily.primary')} !important`,
      //       lineHeight: `${config('theme.lineHeight.24')} !important`,
      //       color: `${config('theme.colors.primary')} !important`
      //     },
      //     '.title': {
      //       fontFamily: `${config('theme.fontFamily.primary')} !important`
      //     }
      //   }
      // };
      // const paragraphs = {
      //   '.paragraph-default': {
      //     fontFamily: `${config('theme.fontFamily.primary')} !important`,
      //     fontSize: 15,
      //     lineHeight: '24px',
      //     fontWeight: 'regular',
      //     textAlign: 'left'
      //   },
      //   '.paragraph-bold': {
      //     fontFamily: `${config('theme.fontFamily.primary')} !important`,
      //     fontSize: 15,
      //     lineHeight: '24px',
      //     fontWeight: 'medium',
      //     textAlign: 'left'
      //   },
      //   '.paragraph-small': {
      //     fontFamily: `${config('theme.fontFamily.primary')} !important`,
      //     fontSize: 14,
      //     lineHeight: '20px',
      //     fontWeight: 'regular',
      //     textAlign: 'left'
      //   },
      //   '.paragraph-large': {
      //     fontFamily: `${config('theme.fontFamily.primary')} !important`,
      //     fontSize: 20,
      //     lineHeight: '32px',
      //     fontWeight: 'regular',
      //     textAlign: 'left'
      //   }
      // };
      // addBase({
      //   ...mobile,
      //   ...desktop,
      //   ...paragraphs
      // });
    }),
    plugin(function ({ addUtilities, config }) {
      const editor = {
        '.DraftEditor-editorContainer': {
          zIndex: 0
        },
        '.rdw-link-decorator-icon': {
          display: 'none'
        }
      };

      const newUtilities = { ...editor };
      addUtilities(newUtilities);
    })
  ]
};
